import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import HorizontalScrollBar from "./HorizontalScrollBar";
import Loader from "./Loader";

const SimilarExercises = ({ targetMuscleExercises, equipmentExercises }) => {
//   return (
//     <Box sx={{ mt: { lg: "100px", xs: "0" } }}>
//       <Typography variant="h3" mb={5} className="text-white">
//         Exercises that target same Muscle Group
//       </Typography>
//       <div sx={{ p: "2" }} className="flex flex-wrap  ">
//         {targetMuscleExercises.length ? (
//           <HorizontalScrollBar data={targetMuscleExercises} />
//         ) : (
//           <Loader />
//         )}
//       </div>
//       <Typography variant="h3" mb={5} className="text-white">
//         Exercises that target same Equipment Group
//       </Typography>
//       <Stack direction="row" sx={{ p: "2", position: "relative" }}>
//         {targetMuscleExercises.length ? (
//           <HorizontalScrollBar data={equipmentExercises} />
//         ) : (
//           <Loader />
//         )}
//       </Stack>
//     </Box>
//   );
};

export default SimilarExercises;
